import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles, categories, testimonials, faqs } from '@/mocks/articles';

const services = [
  {
    icon: 'ri-search-eye-line',
    title: '奸情调查方法',
    desc: '掌握合法有效的调查技巧，从手机定位到行踪追踪，全方位还原真相。',
    link: '/category/diaocha-fangfa',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '婚外情证据收集',
    desc: '学会合法保存聊天记录、转账记录等电子证据，确保证据的法律效力。',
    link: '/category/zhengju-shouji',
  },
  {
    icon: 'ri-scales-line',
    title: '法律维权路径',
    desc: '了解离婚诉讼、财产分割、损害赔偿等法律权益，用法律武器保护自己。',
    link: '/category/falv-weiquan',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '心理疏导建议',
    desc: '从心理学角度提供情绪管理方法，帮助您走出情感创伤，重建自信。',
    link: '/category/xinli-shudao',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '婚姻危机处理',
    desc: '理性分析婚姻状况，提供决策框架和行动指南，帮您做出最有利的选择。',
    link: '/category/hunyin-weiji',
  },
];

const featuredArticles = articles.slice(0, 4);

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20interior%20with%20warm%20amber%20sunlight%20streaming%20through%20large%20window%2C%20abstract%20architectural%20shadows%20on%20cream%20wall%2C%20peaceful%20yet%20strong%20atmosphere%2C%20editorial%20photography%2C%20warm%20terracotta%20and%20soft%20beige%20tones%2C%20harmonious%20composition%2C%20no%20text&width=1600&height=900&seq=hero-main-01&orientation=landscape"
              alt="奸情调查取证全攻略 - 婚姻真相一查到底"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
          </div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <p className="text-accent-400 text-sm md:text-base font-medium tracking-widest mb-4">
              还原真相 · 保护权益 · 重建生活
            </p>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
              奸情调查取证全攻略
              <span className="block text-xl md:text-2xl font-normal mt-3 text-white/80">
                婚姻真相一查到底
              </span>
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              怀疑另一半存在奸情？我们提供专业奸情调查方法、取证技巧、法律维权路径及心理疏导建议，帮助您在婚姻危机中掌握主动权，以合法方式还原真相、保护自身权益。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/diaocha-fangfa"
                className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                开始调查取证
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-md font-medium text-sm hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Core Services Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                核心服务领域
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                从调查取证到法律维权，从心理疏导到危机处理，我们提供一站式婚姻危机解决方案
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {services.map((service) => (
                <Link
                  key={service.title}
                  to={service.link}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                    <i className={`${service.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {service.desc}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  精选文章
                </h2>
                <p className="text-foreground-600 text-sm">
                  最新最实用的调查取证知识与维权指南
                </p>
              </div>
              <Link
                to="/category/diaocha-fangfa"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full">
                        {categories.find(c => c.slug === article.category)?.name}
                      </span>
                      <span className="text-xs text-foreground-500">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-foreground-600 text-sm">来自真实用户的心声与评价</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.slice(0, 6).map((t) => (
                <div
                  key={t.id}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                    <span className="text-xs text-foreground-500">{t.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题解答
              </h2>
              <p className="text-foreground-600 text-sm">关于婚外情调查取证最常被问到的问题</p>
            </div>

            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h3>
                    <i className="ri-add-line text-foreground-500 group-open:hidden text-lg shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-500 hidden group-open:block text-lg shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-14 md:py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20terracotta%20and%20cream%20tones%2C%20minimalist%20geometric%20shapes%2C%20elegant%20and%20calming%20atmosphere%2C%20editorial%20quality%2C%20no%20text%2C%20harmonious%20composition&width=1600&height=600&seq=cta-bg-02&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-primary-900/60 to-primary-800/70"></div>
          </div>

          <div className="relative z-10 w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
              不要让疑惑继续困扰您
            </h2>
            <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
              面对婚姻危机，拖延只会让情况变得更糟。立即开始合法取证，掌握婚姻主动权。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 bg-accent-500 text-background-50 rounded-md font-medium text-sm hover:bg-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              立即联系我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '奸情调查取证全攻略',
            url: 'https://marriagelaw.github.io/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://marriagelaw.github.io/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '奸情调查取证全攻略 - 首页',
            description:
              '怀疑另一半存在奸情？本页提供专业奸情调查方法、取证技巧、法律维权路径及心理疏导建议。',
            isPartOf: {
              '@type': 'WebSite',
              name: '奸情调查取证全攻略',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}